/**
 * Shared multi-account config resolution for AgentVault OpenClaw plugin.
 *
 * Supports two config shapes:
 * 1. Legacy single-agent: channels.agentvault.dataDir (returns ["default"])
 * 2. Multi-agent: channels.agentvault.accounts.{id}.dataDir (returns account keys)
 *
 * When `accounts` key is present, it takes precedence over top-level dataDir.
 */

const DEFAULT_API_URL = "https://api.agentvault.chat";
const DEFAULT_HTTP_PORT = 18790;

export interface ResolvedAccount {
  accountId: string;
  dataDir: string;
  apiUrl: string;
  agentName: string;
  httpPort: number;
  configured: boolean;
}

export function listAccountIds(cfg: any): string[] {
  const av = cfg?.channels?.agentvault;
  if (!av) return [];
  if (av.accounts && typeof av.accounts === "object") {
    return Object.keys(av.accounts);
  }
  return av.dataDir ? ["default"] : [];
}

export function resolveAccount(cfg: any, accountId?: string): ResolvedAccount {
  const av = cfg?.channels?.agentvault ?? {};
  const id = accountId ?? "default";

  if (av.accounts && typeof av.accounts === "object") {
    const acct = av.accounts[id];
    if (!acct) {
      return {
        accountId: id,
        dataDir: "",
        apiUrl: av.apiUrl ?? DEFAULT_API_URL,
        agentName: id,
        httpPort: DEFAULT_HTTP_PORT,
        configured: false,
      };
    }

    let httpPort = acct.httpPort;
    if (httpPort == null) {
      const keys = Object.keys(av.accounts);
      const index = keys.indexOf(id);
      httpPort = DEFAULT_HTTP_PORT + (index >= 0 ? index : 0);
    }

    return {
      accountId: id,
      dataDir: acct.dataDir ?? "",
      apiUrl: acct.apiUrl ?? av.apiUrl ?? DEFAULT_API_URL,
      agentName: acct.agentName ?? id,
      httpPort,
      configured: Boolean(acct.dataDir),
    };
  }

  return {
    accountId: id,
    dataDir: av.dataDir ?? "~/.openclaw/agentvault",
    apiUrl: av.apiUrl ?? DEFAULT_API_URL,
    agentName: av.agentName ?? "OpenClaw Agent",
    httpPort: av.httpPort ?? DEFAULT_HTTP_PORT,
    configured: Boolean(av.dataDir),
  };
}
